import routes from '@modules/stripe/stripe-wallet/stripe-wallet-routes';

export default {
  routes,
};
